import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionsHelper } from '../../app/helpers/permissions.helper';
import { MpsUser } from '../../app/models/mps-user.model';
import { mpsRouteNames } from '../mps-route-names';
import { MpsUserService } from '../services/mps-user.service';

export const MpsCylinderManagementGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.navigateByUrl(mpsRouteNames.auth + '/' + mpsRouteNames.login);
  }

  const user = new MpsUser(loggedInUser);
  return PermissionsHelper.canAccessCylinderManagement(user)
    ? true
    : router.navigateByUrl(mpsRouteNames.auth + '/' + mpsRouteNames.login);
};
